import React from "react";
import PropTypes from "prop-types";

import KompressorImageContainer from "../grundelemente/KompressorImageContainer";

import "./KompressorBild.css";

const KompressorBild = props => (
	<div className="almig-wartung-kompressor-bild">
		<KompressorImageContainer compressor={props.compressor} />
	</div>
);

KompressorBild.propTypes = {
	compressor: PropTypes.object.isRequired
};

export default KompressorBild;
